<template>
  <div>
    <exo-table :root="_self">
      <exo-form :root="_self">
        <v-row>
          <v-col cols="5" class="form-column">
            <exo-input-name :root="_self" gt_PerformanceAnalysis-v-step="9" />
            <exo-input-double
              :root="_self"
              name="payloadPower"
              gt_PerformanceAnalysis-v-step="10"
            />
            <!--exo-input-select :root="_self" name="fieldOfViewType" :disabled="constellationModule">
            </exo-input-select-->
            <exo-input-select :root="_self" name="fieldOfViewType">
            </exo-input-select>
            <exo-input-select :root="_self" name="circularFOVDefinitionType">
              <exo-help-dialog title="Circular field of regard">
                A circular field of regard payload must be defined by its ground
                range (or half swath)
                <katex-element expression="\mathrm{GR}" />, its maximum
                incidence <katex-element expression="\alpha_i" />, its minimum
                elevation <katex-element expression="\alpha_e" />, its semi-view
                angle <katex-element expression="\alpha_s" />
                or its swath.
                <v-img
                  contain
                  :src="
                    require('../../assets/images/tooltip-visibility-parameters.png')
                  "
                  aspect-ratio="3"
                />
                <br />
              </exo-help-dialog>
            </exo-input-select>
            <exo-input-select :root="_self" name="rectangularFOVDefinitionType">
              <exo-help-dialog title="Rectangular field of regard">
                A rectangular field of regard is defined either by the
                cross-track (<katex-element expression="L" />) and along-track
                (<katex-element expression="D" />) swaths, or by the
                corresponding semi-view angles (see circular field of regard
                tooltip).
                <v-img
                  contain
                  :src="
                    require('../../assets/images/tooltip-rectangular-swath.png')
                  "
                  aspect-ratio="3"
                />
              </exo-help-dialog>
            </exo-input-select>
            <div
              v-if="
                this.inputs.circularFOVDefinitionType ===
                'ALTITUDE_AND_GROUND_RANGE'
              "
            >
              <exo-input-double :root="_self" name="groundRangeAlongTrack" />
            </div>
            <div
              v-if="
                this.inputs.circularFOVDefinitionType ===
                'ALTITUDE_AND_MAX_INCIDENCE'
              "
            >
              <exo-input-double :root="_self" name="maxIncidence" />
            </div>
            <div
              v-if="
                this.inputs.circularFOVDefinitionType ===
                'ALTITUDE_AND_MIN_ELEVATION'
              "
            >
              <exo-input-double :root="_self" name="minElevation" />
            </div>
            <div
              v-if="
                this.inputs.circularFOVDefinitionType ===
                'ALTITUDE_AND_SEMI_VIEW_ANGLE'
              "
            >
              <exo-input-double
                :root="_self"
                name="semiViewAngleCircularDefinition"
                gt_PerformanceAnalysis-v-step="11"
              />
            </div>
            <div
              v-if="
                this.inputs.rectangularFOVDefinitionType === 'SEMI_VIEW_ANGLES'
              "
            >
              <exo-input-double :root="_self" name="semiViewAngleCrossTrack" />
            </div>
            <div
              v-if="
                this.inputs.rectangularFOVDefinitionType === 'SEMI_VIEW_ANGLES'
              "
            >
              <exo-input-double :root="_self" name="semiViewAngleAlongTrack" />
            </div>
            <div
              v-if="
                this.inputs.circularFOVDefinitionType === 'ALTITUDE_AND_SWATH'
              "
            >
              <exo-input-double :root="_self" name="swathCircularDefinition" />
            </div>
            <div
              v-if="
                this.inputs.rectangularFOVDefinitionType ===
                'SWATH_AND_SWATH_WIDTH'
              "
            >
              <exo-input-double :root="_self" name="swathCrossTrack" />
            </div>
            <div
              v-if="
                this.inputs.rectangularFOVDefinitionType ===
                'SWATH_AND_SWATH_WIDTH'
              "
            >
              <exo-input-double :root="_self" name="swathAlongTrack" />
            </div>
            <v-divider></v-divider>
            <exo-input-select :root="_self" name="constantParameterChoice" />
            <exo-input-double :root="_self" name="nominalAltitude">
              <exo-help-dialog title="Nominal altitude">
                The nominal altitude of the payload is the altitude for which
                you know the value of the field of regard definition parameter
                you chose.
              </exo-help-dialog>
            </exo-input-double>
            <exo-input-select :root="_self" name="constantParameterType">
              <exo-help-dialog title="Constant visibility parameter type">
                This is the parameter that you choose to keep constant for your
                payload.
                <br />
                <br />
                If your payload is orbiting at an operating altitude different
                from its nominal altitude, we need to recompute all visibility
                parameters to take this change of altitude into account. The
                constant parameter will remain unchanged.
                <br />
                <br />
                You can choose any visibility parameter to stay constant, even
                if it is different from the definition type.
                <br />
                <br />
                You can choose between center angle
                <katex-element expression="\alpha_c" />, ground range (or half
                swath) <katex-element expression="\mathrm{GR}" />, its maximum
                distance to target <katex-element expression="d" />, its maximum
                incidence <katex-element expression="\alpha_i" />, its minimum
                elevation <katex-element expression="\alpha_e" />, or its
                semi-view angle <katex-element expression="\alpha_s" />.
                <v-img
                  contain
                  :src="
                    require('../../assets/images/tooltip-visibility-parameters.png')
                  "
                  aspect-ratio="3"
                />
              </exo-help-dialog>
            </exo-input-select>
            <div>
              <exo-input-select
                :root="_self"
                name="telecomType"
                gt_PerformanceAnalysis-v-step="12"
              >
                <exo-help-dialog title="Telecom properties">
                  <tooltipPayloadTelecom />
                </exo-help-dialog>
              </exo-input-select>
              <exo-input-double
                :root="_self"
                name="uplinkRate"
                gt_PerformanceAnalysis-v-step="13"
              />
              <!-- <exo-input-double :root="_self" name="downlinkRate" /> -->
            </div>
            <div gt_PerformanceAnalysis-v-step="14" />
          </v-col>
          <v-col cols="7">
            <cesium-viewer
              :computedPayload="computedPayloadFOV"
              :nominalAltitude="nominalAltitudeForViewer"
              v-on:updatedDisplayAltitude="updateDisplayAltitude"
            />
          </v-col>
        </v-row>
      </exo-form>
    </exo-table>
    <exo-modal-references :root="_self" :modalContent="modalRef" />
    <v-tour
      name="performanceAnalysisTourPayload"
      :steps="steps_payload"
      :callbacks="customCallbacks"
    ></v-tour>
  </div>
</template>

<script>
import formMixin from '../../mixins/forms.js'
import formAnalyticalMixin from '../../mixins/analyticalFoms.js'
import constellationComponentsLoader from '../../components/Forms/analyticalConstellationsComponents.js'
import { mapGetters, mapActions } from 'vuex'
import dataTools from '../../tools/data'
import fieldsDescription from '../../tools/fieldsDescription'
import tooltipPayloadTelecom from '../../components/Tooltips/ConstellationModule/tooltipPayloadTelecom'
import PayloadViewer from './PayloadViewer.vue'
import './formsStyle.css'
import guidedTutorialPerformanceAnalysis, {
  steps_payload
} from '../../components/GuidedTutorials/guidedTutorialPerformanceAnalysis.js'

constellationComponentsLoader()

export default {
  name: 'AnalyticalConstellationPayload',

  components: {
    tooltipPayloadTelecom,
    'cesium-viewer': PayloadViewer
  },

  mixins: [formMixin, formAnalyticalMixin],

  mounted: function () {
    if (this.gt_PerformanceAnalysis.isActive) {
      setTimeout(
        () => this.$tours['performanceAnalysisTourPayload'].start(),
        400
      )
    }
  },

  data() {
    return {
      tableFields: [
        { value: 'displayedName', text: 'Name', sortable: true },
        {
          value: 'payloadPower',
          text:
            this.getLabel('payloadPower') +
            this.getDefaultUnitLabel('payloadPower'),
          sortable: true
        },
        {
          value: 'fieldOfViewType',
          text:
            this.getLabel('fieldOfViewType') +
            this.getDefaultUnitLabel('fieldOfViewType'),
          sortable: true
        },
        {
          value: 'nominalAltitude',
          text:
            this.getLabel('nominalAltitude') +
            this.getDefaultUnitLabel('nominalAltitude'),
          sortable: true
        },
        {
          value: 'swathCrossTrack',
          text:
            this.getLabel('swathCrossTrack') +
            this.getDefaultUnitLabel('swathCrossTrack'),
          sortable: true
        },
        {
          value: 'swathAlongTrack',
          text:
            this.getLabel('swathAlongTrack') +
            this.getDefaultUnitLabel('swathAlongTrack'),
          sortable: true
        },
        {
          value: 'semiViewAngleCrossTrack',
          text:
            this.getLabel('semiViewAngleCrossTrack') +
            this.getDefaultUnitLabel('semiViewAngleCrossTrack'),
          sortable: true
        },
        {
          value: 'semiViewAngleAlongTrack',
          text:
            this.getLabel('semiViewAngleAlongTrack') +
            this.getDefaultUnitLabel('semiViewAngleAlongTrack'),
          sortable: true
        },
        {
          value: 'minElevation',
          text:
            this.getLabel('minElevation') +
            this.getDefaultUnitLabel('minElevation'),
          sortable: true
        },
        { value: 'actions', text: 'Actions', sortable: false }
      ],

      modalRef: { content: [] },
      showModal: false,

      enumPropertiesList: this.getEnumProperties(),

      steps_payload: steps_payload,
      customCallbacks: {
        onNextStep: (currentStep) => {
          guidedTutorialPerformanceAnalysis.onNextStepPayload(currentStep, this)
        },
        onSkip: () => {
          guidedTutorialPerformanceAnalysis.onSkipPayload(this)
        },
        onFinish: () => {
          guidedTutorialPerformanceAnalysis.onFinishSubmit(this)
        }
      },

      inputs: {
        nominalAltitude: this.getDefaultValue('nominalAltitude'),
        payloadPower: this.getDefaultValue('payloadPower'),
        circularFOVDefinitionType: this.getDefaultValue(
          'circularFOVDefinitionType'
        ),
        rectangularFOVDefinitionType: this.getDefaultValue(
          'rectangularFOVDefinitionType'
        ),
        constantParameterType: this.getDefaultValue('constantParameterType'),
        constantParameterChoice: this.getDefaultValue(
          'constantParameterChoice'
        ),
        groundRangeAlongTrack: this.getDefaultValue('groundRangeAlongTrack'),
        maxIncidence: this.getDefaultValue('maxIncidence'),
        minElevation: this.getDefaultValue('minElevation'),
        semiViewAngleAlongTrack: this.getDefaultValue(
          'semiViewAngleAlongTrack'
        ),
        semiViewAngleCircularDefinition: this.getDefaultValue(
          'semiViewAngleCircularDefinition'
        ),
        swathAlongTrack: this.getDefaultValue('swathAlongTrack'),
        swathCircularDefinition: this.getDefaultValue(
          'swathCircularDefinition0'
        ),
        swathCrossTrack: this.getDefaultValue('swathCrossTrack'),
        fieldOfViewType: this.getDefaultValue('fieldOfViewType'),
        uplinkRate: this.getDefaultValue('uplinkRate'),
        downlinkRate: this.getDefaultValue('downlinkRate'),
        telecomType: this.getDefaultValue('telecomType'),
        displayAltitude: 600,
        scope: this.getDefaultValue('scope')
      },
      computedPayloadFOV: {}
    }
  },

  methods: {
    ...mapActions(['setCurrentMission']),

    getPayloadType(instance) {
      let types = {
        fieldOfViewType: instance.fieldOfViewType,
        telecomType: instance.telecomType
      }
      if (instance.fieldOfViewType === 'TYPE_CIRCULAR') {
        types.circularFOVDefinitionType = instance.circularFOVDefinitionType
        types.constantParameterChoice = instance.constantParameterChoice
      } else if (instance.fieldOfViewType === 'TYPE_RECTANGULAR') {
        types.rectangularFOVDefinitionType =
          instance.rectangularFOVDefinitionType
      }
      return types
    },

    getRequiredPropertiesList(instance) {
      let objectType = this.getCurrentFormType()
      return dataTools.getPropertiesList(
        fieldsDescription[objectType],
        this.getPayloadType(instance),
        'required'
      )
    },

    getOptionalPropertiesList(instance) {
      let objectType = this.getCurrentFormType()
      return dataTools.getPropertiesList(
        fieldsDescription[objectType],
        this.getPayloadType(instance),
        'optional'
      )
    },

    getAllPropertiesUnionList() {
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        null,
        'required'
      )
      let optionalList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        null,
        'optional'
      )
      return [...new Set(requiredList.concat(optionalList))]
    },

    getCurrentFormTitle() {
      return 'Payload'
    },

    getCurrentFormType() {
      return 'PayloadDefinition'
    },

    async computePayload() {
      let data = await this.$http
        .post('/physics/computedpayload', {
          payload: this.createObjectFromForm(),
          altitude: parseFloat(this.inputs.displayAltitude) * 1e3,
          inclination: 0
        })
        .then(function (response) {
          return response.data
        })
        .catch((e, __) => {
          this.errorTrace = this.getErrorMessage(e)
          return null
        })
      this.computedPayloadFOV = data.fieldOfView
    },

    updateDisplayAltitude(altitude) {
      this.inputs.displayAltitude = parseFloat(altitude)
    }
  },

  computed: {
    ...mapGetters(['currentMission', 'gt_PerformanceAnalysis']),

    constellationModule() {
      if (this.currentMission != null) {
        return (
          this.currentMission?.typeName ===
            'ConstellationOptimizationRequest' ||
          this.currentMission?.typeName === 'ConstellationSimulationRequest' ||
          this.currentMission?.typeName === 'ConstellationGenerationRequest'
        )
      } else {
        return false
      }
    },

    constellationMission() {
      if (this.currentMission != null) {
        return (
          this.currentMission.typeName ===
            'ConstellationPerformanceAnalysisRequest' ||
          this.currentMission.typeName === 'ConstellationGenerationRequest' ||
          this.currentMission.typeName === 'ConstellationOptimizationRequest' ||
          this.currentMission.typeName === 'ConstellationSimulationRequest'
        )
      } else {
        return false
      }
    },

    simulationMission() {
      if (this.currentMission != null) {
        return this.currentMission.typeName === 'SimulationRequest'
      } else {
        return false
      }
    },
    nominalAltitudeForViewer() {
      return this.inputs.constantParameterChoice === 'SAME'
        ? null
        : this.inputs.nominalAltitude
    }
  },
  watch: {
    inputs: {
      async handler() {
        if (this.paramsValid) {
          window.setTimeout(() => {
            this.computePayload()
          }, 0.5e3)
        }
      },
      deep: true
    }
  }
}
</script>
